import styled from "styled-components";
import { colors } from "../../../../assets";

export const ModalCreatePointsContainer = styled.div`
  display: flex;
  color: ${colors["PR-001-100"]};
  position: fixed;
  z-index: 100;
  background: ${colors["background-modal"]};
  left: 0;
  width: 100%;
  top: 0;
  align-items: center;
  justify-content: center;
  /* height: 100vh; */
  height: 100%;
  overflow: scroll;

  .modal-create-points-more {
    font-family: Museo Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    color: #6cc9f0;
    cursor: pointer;
  }

  .modal-create-points-step {
    color: ${colors["PR-001-100"]};
    font-family: Museo Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.04em;
    margin-left: 82px;
    margin-bottom: 16px;
    text-transform: uppercase;
  }

  .modal-create-points-aux-container {
    padding: 100px;
    height: 100%;
  }

  .modal-create-points-container {
    background: #ffffff;
    border-radius: 3px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    padding: 20px 22px 40px 40px;
    max-width: 620px;
    width: 620px;
    /* max-height: 90vh;
    overflow: hidden; */
  }

  .modal-create-points-close {
    text-align: right;
    img {
      max-width: 18px;
      cursor: pointer;
    }
  }

  .modal-create-points-header {
    &-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      &__icon {
        display: flex;
        background: rgba(179, 202, 220, 0.3);
        width: 62px;
        min-width: 62px;
        height: 62px;
        border-radius: 50%;
        align-items: center;
        justify-content: center;

        img {
          max-width: 20px;
        }
      }
      &__text {
        margin-left: 20px;
      }
    }
  }

  .modal-create-points-subtitle {
    margin-top: 8px;
    margin-bottom: 33px;
    margin-left: 82px;
    font-family: Museo Sans;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 22px;
    color: ${colors["TX-001-50"]};
  }

  .modal-create-points-wrapper {
    padding-right: 54px;
  }

  .modal-create-points-main {
    margin-left: 82px;
    &__field {
      margin-bottom: 38px;
    }
    &__title {
      padding-right: 12px;
      margin-bottom: 34px;
      font-family: Museo Sans;
      font-style: normal;
      margin-left: 14px;
      font-size: 18px;
      line-height: 26px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        height: 24px;
        width: 24px;
        cursor: pointer;
      }
    }
  }

  .modal-create-points-buttons {
    margin-left: 82px;
    margin-top: 56px;
    display: flex;
    &__item {
      margin-right: 20px;
      width: 160px;
    }
  }

  .modal-col-50 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
  .modal-col-100 {
    display: grid;
    grid-template-columns: 1fr;
  }
`;
